<template>
<div class="col-xs-12">
  <div class="card float-e-margins">
    <div class="card-title">
        <h1>Rubrieken aanpassen</h1>
    </div>
    <div class="card-content no-padding">
      <div class="row">
        <div class="col-xs-12">
          <!--start Rubriek-->
          <div class="card float-e-margins">
            <div class="card-title" style="background-color:#2C3E50;">
              <div class="col-lg-6">
                <h5 style="color:white;">
                  Rubrieken
                </h5>
              </div>
            </div>
            <div class="row">
              <div class="card-content no-padding">
                <div class="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
                  <!-- start new category without parent -->
                  <a @click="setModal(0)"><span class="glyphicon glyphicon-plus"></span>Nieuwe rubriek toevoegen</a>
                  <!--end new category without parent -->
                  <!--start category list -->
                  <div class="panel panel-default" v-for="item in rubrieks">
                    <div class="panel-heading" role="tab" id="heading">
                      <h4 v-if="!item.Editable" class="panel-title">
                        <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#{{item.MenuItemId}}" aria-expanded="false" aria-controls="{{item.MenuItemId}}">
                          {{item.MenuText}}
                        </a>
                        <p>
                          <a @click="item.Editable = true" class="text-right">
                            <span class="glyphicon glyphicon-pencil"></span>
                            Wijzigen
                          </a>
                        </p>
                      </h4>
                      <div v-else class="panel-heading" role="tab" id="headingOne">
                            <div class="form-inline">
                              <div class="form-group">
                                <label class="sr-only" for="categoryname">Rubriek naam</label>
                                <input type="email" class="form-control" id="categoryname" v-model="item.MenuText">
                              </div>
                              <button type="button" class="btn btn-success" @click="edit(item)">Opslaan</button>
                              <button type="button" class="btn btn-default" @click="refresh()">Annuleren</button>
                              <button type="button" class="btn btn-danger" @click="deleteCategory(item.MenuItemId)">Verwijderen</button>
                              <vc-alert successmessage="Rubriek succesvol bijgewerkt!" :success.sync="editsuccess" :error.sync="editerror">
                              </vc-alert>
                            </div>
                      </div>
                    </div>
                    <div id="{{item.MenuItemId}}" class="panel-collapse collapse" role="tabpanel" aria-labelledby="heading">
                      <div class="panel-body">
                        <a @click="setModal(item.MenuItemId)">
                          <span class="glyphicon glyphicon-plus"></span>
                          Nieuwe subrubriek toevoegen voor {{item.MenuText}}
                        </a>
                        <!--start subcategory list -->
                        <div v-for="subitem in item.Children | orderBy 'MenuText'" class="panel panel-default">
                          <div v-if="!subitem.Editable" class="panel-heading" role="tab" id="headingOne">
                            <p class="panel-title">
                            {{subitem.MenuText}}
                            </p>
                            <a @click="subitem.Editable = true">
                              <span @click="subitem.Editable = true" class="glyphicon glyphicon-pencil"></span>
                              Wijzigen
                            </a>
                          </div>
                          <div v-else class="panel-heading" role="tab" id="headingOne">
                            <div class="form-inline">
                              <div class="form-group">
                                <label class="sr-only" for="subcategoryname">Rubriek naam</label>
                                <input type="email" class="form-control" id="subcategoryname" v-model="subitem.MenuText">
                              </div>
                              <button type="button" class="btn btn-success" @click="edit(subitem)">Opslaan</button>
                              <button type="button" class="btn btn-default" @click="refresh()">Annuleren</button>
                              <button type="button" class="btn btn-danger" @click="deleteCategory(subitem.MenuItemId)">Verwijderen</button>
                              <vc-alert v-if="modalsuccess" type="success"
                                :timeout="4000">
                                Rubriek succesvol bijgewerkt!
                              </vc-alert>
                            </div>
                          </div>
                        </div>
                        <!--end category list -->
                      </div>
                    </div>
                  </div>
                  <!--end category list -->
                </div>
              </div>
            </div>
          </div>
          <!--end Rubriek-->



        </div>
      </div>
    </div>
  </div>
  <!-- Start modal for add new Category -->
  <v-modal :show.sync="showCustomModal" effect="fade" width="400">
    <div slot="modal-header" class="modal-header">
      <h4 class="modal-title">
        <b>Nieuwe rubriek toevoegen</b>
      </h4>
    </div>
    <div slot="modal-body" class="modal-body">
      <div class="form-group">
        <label for="rubriekName">Rubriek naam:</label>
        <input type="text" class="form-control" id="rubriekName" v-model="newCategoryName">
      </div>
    </div>
    <div slot="modal-footer" class="modal-footer">
      <button type="button" class="btn btn-success" @click="save()">Opslaan</button>
      <!-- after save start -->
      <vc-alert v-if="modalsuccess" type="success"
        :timeout="4000">
        Rubriek succesvol toegevoegd!
      </vc-alert>
      <vc-alert v-if="modalerror" type="danger" :dismissible="false">
         Er is een fout opgetreden!
      </vc-alert>
      <!-- after save end -->
    </div>
  </v-modal>

</div>
</template>
<script>
import store from '../../store'
import callbackalert from '../Common/CallbackAlert'
import modal from '../Common/Modal'
export default {
  route: {
    canReuse: false
  },
  created () {
    this.getRubrieks()
  },
  ready () {
  },
  components: {
    'vc-alert': callbackalert,
    'v-modal': modal
  },
  data () {
    return {
      store: store,
      rubrieks: [],
      modalsuccess: false,
      modalerror: false,
      editsuccess: false,
      editerror: false,
      showCustomModal: false,
      selectedParent: 0
    }
  },
  methods: {
    getRubrieks: function () {
      $.ajax({
        type: 'GET',
        url: store.root + 'api/MenuItems/',
        xhrFields: {
          withCredentials: true
        }
      }).done(function (data) {
        for (var i = 0; i < data.length; i++) {
          data[i].Editable = false
          for (var c = 0; c < data[i].Children.length; c++) {
            data[i].Children[c].Editable = false
          }
        }
        this.rubrieks = data
      }.bind(this))
    },
    handleRubriek: function (newCategory) {
      $.ajax({
        type: 'POST',
        url: store.root + 'api/MenuItems',
        data: newCategory,
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Authorization', 'Bearer ' + store.token)
        },
        xhrFields: {
          withCredentials: true
        }
      }).done(function () {
        this.modalsuccess = true
        this.modalerror = false
        setTimeout(function () { location.reload(true) }, 2000)
      }.bind(this))
      .fail(function (response) {
        console.log(response)
        this.modalsuccess = false
        this.modalerror = true
      }.bind(this))
    },
    refresh: function () {
      location.reload(true)
    },
    save: function () {
      var newCategory
      if (this.selectedParent > 0) {
        newCategory = { MenuText: this.newCategoryName, ParentMenuItemId: this.selectedParent, MenuId: 1 }
      } else {
        newCategory = { MenuText: this.newCategoryName, MenuId: 1 }
      }
      this.handleRubriek(newCategory)
    },
    setModal: function (id) {
      this.newCategoryName = ''
      this.selectedParent = id
      this.showCustomModal = true
    },
    edit: function (item) {
      $.ajax({
        type: 'PUT',
        url: store.root + 'api/MenuItems',
        data: item,
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Authorization', 'Bearer ' + store.token)
        },
        xhrFields: {
          withCredentials: true
        }
      }).done(function () {
        this.editsuccess = true
        this.editerror = false
        setTimeout(function () { location.reload(true) }, 2000)
      }.bind(this))
      .fail(function (response) {
        console.log(response)
        this.editsuccess = false
        this.editerror = true
      }.bind(this))
    },
    deleteCategory: function (id) {
      $.ajax({
        type: 'DELETE',
        url: store.root + 'api/MenuItems/' + id,
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Authorization', 'Bearer ' + store.token)
        },
        xhrFields: {
          withCredentials: true
        }
      }).done(function () {
        // this.editsuccess = true
        // this.editerror = false
        location.reload(true)
      }.bind())
      .fail(function (response) {
        console.log(response)
        this.editsuccess = false
        this.editerror = true
      }.bind(this))
    }
  },
  computed: {
  }
}
</script>

<style scoped>
.float-e-margins .btn {
  margin-bottom: 0 !important;
}
</style>


// WEBPACK FOOTER //
// addEditRubrics.vue?21773a54